import { APIClient } from "../helpers/api_helper";
import * as url from "../helpers/url_helper";
import { TenantRentalConfig } from "../interfaces/TenantRentalConfig";

const api = new APIClient();

export const getRentalConfig = async (
  tenantId: string
): Promise<TenantRentalConfig | null> => {
  // Real API call - use path parameter: /TenantRentalConfiguration/tenant/{tenantId}
  const apiUrl = `${url.GET_TENANT_RENTAL_CONFIG}/tenant/${tenantId}`;
  
  try {
    const response = await api.get(
      apiUrl,
      {} // Empty params object since tenantId is in the path
    ) as unknown as Promise<TenantRentalConfig>;
    return response;
  } catch (error: any) {
    // If API returns 401, let axios interceptor handle redirect
    if (error.response?.status === 401) {
      // Re-throw to let axios interceptor handle redirect to login
      throw error;
    }
    // If API returns 404 or similar, return null to indicate no data found
    if (error.response?.status === 404) {
      return null;
    }
    // Handle timeout errors gracefully
    if (error?.code === 'ECONNABORTED' || error?.message?.includes('timeout')) {
      return null;
    }
    // Re-throw other errors
    throw error;
  }
};

export const createRentalConfig = async (
  data: Partial<TenantRentalConfig>
): Promise<TenantRentalConfig> => {
  try {
    const response = await api.create(
      url.UPDATE_TENANT_RENTAL_CONFIG,
      data
    ) as unknown as Promise<TenantRentalConfig>;
    return response;
  } catch (error: any) {
    // If API returns 401, let axios interceptor handle redirect
    if (error.response?.status === 401) {
      // Re-throw to let axios interceptor handle redirect to login
      throw error;
    }
    // Re-throw other errors
    throw error;
  }
};

export const updateRentalConfig = async (
  id: string,
  data: Partial<TenantRentalConfig>
): Promise<TenantRentalConfig> => {
  try {
    const response = await api.put(
      url.UPDATE_TENANT_RENTAL_CONFIG + "/" + id,
      data
    ) as unknown as Promise<TenantRentalConfig>;
    return response;
  } catch (error: any) {
    // If API returns 401, let axios interceptor handle redirect
    if (error.response?.status === 401) {
      // Re-throw to let axios interceptor handle redirect to login
      throw error;
    }
    // Re-throw other errors
    throw error;
  }
};